import { render } from "./admin-imported-scans.vue?vue&type=template&id=a4f9ad50&ts=true&lang=pug"
import script from "./admin-imported-scans.vue?vue&type=script&lang=ts"
export * from "./admin-imported-scans.vue?vue&type=script&lang=ts"

import "./admin-imported-scans.vue?vue&type=style&index=0&id=a4f9ad50&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__